import Card from 'components/card';
import { MdDelete, MdPlayArrow, MdCalendarToday, MdFactory } from 'react-icons/md';
import { dateToFrench } from 'utils/date';
import { getIcon } from 'utils/icons';

const PlannedProductionItem = (props: {
    production: any;
    onView: () => void;
    onDelete: () => void;
}) => {
    const { production, onView, onDelete } = props;
    const isProductNotFound = production.productName === 'Product not found';

    return (
        <Card extra="group w-full overflow-hidden transition-all duration-200 hover:shadow-lg border-l-4 border-l-toola-500">
            <div className="relative p-4">
                {/* Status badge */}
                <div className="absolute top-3 right-3 z-0">
                    <div className="flex items-center gap-1.5 rounded-full bg-green-100 px-3 py-1 dark:bg-green-900/30 ">
                        <div className="h-2 w-2 animate-pulse rounded-full bg-green-500"></div>
                        <span className="text-xs font-bold text-green-700 dark:text-green-400 ">PLANIFIÉ</span>
                    </div>
                </div>

                <div className="flex flex-col gap-3">
                    {/* Image and info section */}
                    <div className="flex items-start gap-3">
                        <div className="relative">
                            <div className="flex h-16 w-16 items-center justify-center overflow-hidden rounded-xl bg-gray-50 dark:bg-navy-700">
                                <img
                                    className="h-14 w-14 rounded-lg object-contain"
                                    src={getIcon(production.productName, 'product')}
                                    alt={production.productName}
                                />
                            </div>
                            {/* Quantity badge */}
                            <div className="absolute -bottom-1 -right-1 flex h-6 w-6 items-center justify-center rounded-full bg-toola-500 text-xs font-bold text-white">
                                {production.quantity}
                            </div>
                        </div>

                        <div className="flex-1 min-w-0">
                            <h5 className={`text-base font-bold leading-tight ${
                                isProductNotFound 
                                    ? 'text-red-600 dark:text-red-400' 
                                    : 'text-navy-700 dark:text-white'
                            }`}>
                                {isProductNotFound
                                    ? "⚠️ Le produit n'existe plus"
                                    : production.productName}
                            </h5>
                            
                            <div className="mt-2 flex flex-wrap items-center gap-2">
                                <div className="flex items-center gap-1 rounded-lg bg-gray-100 px-2 py-1 dark:bg-navy-700">
                                    <MdFactory className="h-3.5 w-3.5 text-gray-600 dark:text-gray-400" />
                                    <span className="text-xs font-medium text-gray-600 dark:text-gray-400">
                                        {production.quantity} {production.quantity > 1 ? 'unités' : 'unité'}
                                    </span>
                                </div>
                                
                                {production.date && (
                                    <div className="flex items-center gap-1 rounded-lg bg-gray-100 px-2 py-1 dark:bg-navy-700">
                                        <MdCalendarToday className="h-3.5 w-3.5 text-gray-600 dark:text-gray-400" />
                                        <span className="text-xs font-medium text-gray-600 dark:text-gray-400">
                                            {dateToFrench(production.date)}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Actions */}
                    <div className="flex gap-2 pt-2">
                        <button
                            onClick={onView}
                            className="flex flex-1 items-center justify-center gap-2 rounded-lg bg-toola-500 px-3 py-2 font-medium text-white transition-all duration-200 hover:bg-toola-600"
                        >
                            <MdPlayArrow className="h-4 w-4" />
                            <span className="text-sm">Lancer</span>
                        </button>
                        <button
                            onClick={onDelete}
                            className="flex items-center justify-center gap-2 rounded-lg bg-red-50 px-3 py-2 font-medium text-red-600 transition-all duration-200 hover:bg-red-100 dark:bg-red-900/20 dark:text-red-400 dark:hover:bg-red-900/30"
                        >
                            <MdDelete className="h-4 w-4" />
                            <span className="hidden sm:inline text-sm">Supprimer</span>
                        </button>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default PlannedProductionItem;
